(() => {
  const view = 'jbs-soft-clay-botanical-v2';
  if (new URLSearchParams(window.location.search).get('view') !== view) return;
  const install = () => {
    if (!document.getElementById('JbsCollectionBotanicalV2')) return;
    document.querySelectorAll('facets-form-component form').forEach(form => {
      if (form.querySelector('input[name="view"]')) return;
      const input = document.createElement('input');
      input.type = 'hidden'; input.name = 'view'; input.value = view;
      form.append(input);
    });
  };
  install();
  const main = document.getElementById('MainContent');
  if (main) new MutationObserver(install).observe(main, {childList:true, subtree:true});
})();
